import React from 'react'
const TextSummarizerViewResult = ({result}) => { 
  
  // Get the data from either result.summary or result.response.summary
  const summaryData = result?.summary || result?.response?.summary || {};
  const analysisData = result?.analysis || result?.response?.analysis || {};

  return (
    <div className="mt-4 overflow-x-auto">
      <table className="table table-zebra w-full">
        <thead>
          <tr className="bg-base-200">
            <th className="font-bold">Type</th> 
            <th className="font-bold">Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Main Summary</td>
            <td>{summaryData?.main || '-'}</td>
          </tr>
          <tr>
            <td>Key Points</td>
            <td>{summaryData?.bullets?.join(', ') || '-'}</td>
          </tr>
          <tr>
            <td>Length Statistics</td>
            <td>
              Summary: {summaryData?.length?.summary || '-'} words<br/>
              Original: {summaryData?.length?.original || '-'} words<br/>
              Reduction: {summaryData?.length?.reduction_percentage || '-'}%
            </td>
          </tr>
          <tr>
            <td>Key Themes</td>
            <td>{analysisData?.key_themes?.join(', ') || '-'}</td>
          </tr>
          <tr>
            <td>Main Points</td>
            <td>{analysisData?.main_points?.join(', ') || '-'}</td>
          </tr>
          <tr>
            <td>Important Entities</td>
            <td>{analysisData?.important_entities?.join(', ') || '-'}</td>
          </tr>
          <tr>
            <td>Critical Relationships</td>
            <td>{analysisData?.critical_relationships?.join(', ') || '-'}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default TextSummarizerViewResult